import { isRPSOCRAccount } from '../../flows/front-office/shared/utils';

export const toDollarAmountOrDash = val => {
  return val ? `$${Number(val).toLocaleString('en-US')}` : '-';
};

export const getSectionHeading = (showInvestmentAmt, accountType) => {
  const isRPSAccount = isRPSOCRAccount(accountType);

  return showInvestmentAmt || isRPSAccount
    ? 'My Information'
    : 'Account Holder';
};

export const contribInvestmentAmtText = `*Amount shown is calculated based on the annual IRA Contribution Limit minus any 
amounts already contributed, pending or scheduled to your T. Rowe Price IRAs. Your Contributions to Date and 
Contribution Amount Remaining do not include IRA contributions to Brokerage Advantage accounts or Workplace Retirement accounts.
You cannot contribute more than your earned income for the year.`;

export const states = [
  'AA',
  'AE',
  'AP',
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'DC',
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY'
];

export const shouldDisableDoneBtn = (showSuccess, phoneNumberRequired) => {
  return showSuccess || phoneNumberRequired;
};
